import { API } from '../constants/config';
import ApiRequestHeader from '../utils/ApiRequestHeader';
import { fetchWrapper } from '../utils';

const getEndpointBaseUrl = (api, mock) =>
  mock ? API[api].MOCK_BASE_URL : API[api].BASE_URL;

const callApi = (params) => {
  const {
    api = 'ACCOUNTS',
    method,
    endpoint,
    body,
    mock = false,
    conf,
    no_content,
  } = params;

  const fullUrl = getEndpointBaseUrl(api, mock) + endpoint;

  const authRequestHeader = ApiRequestHeader();

  return fetchWrapper(
    fullUrl,
    authRequestHeader,
    method,
    body,
    conf,
    no_content
  );
};

export { callApi };
